import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import { Button } from "@material-ui/core";
import { isFirefox } from "react-device-detect";
import { useSelector } from "react-redux";

import React from "react";
export default function CryptoWalletDialog({
  open,
  handleClickOpen,
  message,
  handleClose,
}) {
  const darkMode = useSelector((state) => state.trading.DARK_MODE);
  return (
    <Dialog
      open={open}
      onClose={handleClose}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <DialogTitle id="alert-dialog-title">{message.title}</DialogTitle>
      <DialogContent>
        <DialogContentText id="alert-dialog-description">
          {message.content}
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button
          onClick={handleClose}
          color="primary"
          variant="contained"
          style={{
            color: "white",
            fontWeight: "bold",
            marginRight: "17px",
            marginBottom: "12px",
          }}
        >
          Ok
        </Button>
      </DialogActions>
    </Dialog>
  );
}
